module.exports = __webpack_public_path__ + "img/miniCode.0050fd7f.jpg";